import { emptyFragment, IconButton, PaperPlaneTopIcon } from '@execonline-inc/execonline-ui';
import { noop } from '@kofno/piper';
import { observer } from 'mobx-react';
import { useRef } from 'react';
import { chatStore } from '../ChatStores/ChatStore';
import ChatHandlers from './ChatHandlers';
import Messages from './Messages';
import ScrollToBottomButton from './ScrollToBottomButton';
import LicenseSelector from './LicenseSelector';

function Chat() {
  const messagesEndRef = useRef<HTMLDivElement | null>(null);
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);
  const { handleSubmit, handleInputChange, handleKeyDown } = ChatHandlers(textareaRef);

  switch (chatStore.state.kind) {
    case 'disconnected':
      return emptyFragment();
    case 'error':
      const { state } = chatStore;
      return (
        <div className="flex absolute inset-0 flex-col bg-white xxl:w-[480px]">
          <Messages messagesEndRef={messagesEndRef} messages={state.messages} />
          <ScrollToBottomButton messagesEndRef={messagesEndRef} />
          <form className="flex pt-3 px-4 pb-4 border-solid border-t-1 w-full" onSubmit={noop}>
            <textarea
              ref={textareaRef}
              autoComplete="off"
              className="border-none rounded-sm overflow-y placeholder:text-gray-300 placeholder:opacity-0.3 focus:ring-[#09A6FF52] resize-none w-full placeholder-gray-500 text-sm"
              value={state.nextMessage}
              style={{ maxHeight: '8rem' }}
              placeholder="Type your message here..."
              rows={1}
              onChange={handleInputChange}
              onKeyDown={noop}
            />
            <IconButton type="submit" aria-label="Send message">
              <PaperPlaneTopIcon className="ml-2" color={'teal'} disabled={true} />
            </IconButton>
          </form>
        </div>
      );
    case 'ready':
    case 'streaming':
    case 'streaming-and-receiving-input': {
      const { state } = chatStore;
      return (
        <div className="flex absolute inset-0 flex-col bg-white xxl:w-[480px]">
          <Messages messagesEndRef={messagesEndRef} messages={state.messages} />
          <ScrollToBottomButton messagesEndRef={messagesEndRef} />
          <form
            className="flex pt-3 px-4 pb-4 border-solid border-t-1 w-full"
            onSubmit={handleSubmit(state)}
          >
            <textarea
              ref={textareaRef}
              autoComplete="off"
              className="border-none rounded-sm overflow-y placeholder:text-gray-300 placeholder:opacity-0.3 focus:ring-[#09A6FF52] resize-none w-full placeholder-gray-500 text-sm"
              value={state.nextMessage}
              style={{ maxHeight: '8rem' }}
              placeholder="Type your message here..."
              rows={1}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown(state)}
            />
            <IconButton type="submit" aria-label="Send message">
              <PaperPlaneTopIcon
                className="ml-2"
                color={'teal'}
                disabled={state.kind !== 'ready' || !state.nextMessage}
              />
            </IconButton>
          </form>
          <LicenseSelector />
        </div>
      );
    }
  }
}

export default observer(Chat);
